// src/services/pricingDataService.js
// CANONICAL PASSTHROUGH - NO TRANSFORMATION!

import { leaguesAPI } from './apiService';

class PricingDataService {
  constructor() {
    this.cachedData = null;
    this.cacheTimestamp = null;
    this.CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
  }

  async getPricingData(leagueId, forceRefresh = false) {
    // Check cache
    if (!forceRefresh && this.cachedData && this.cacheTimestamp) {
      const cacheAge = Date.now() - this.cacheTimestamp;
      if (cacheAge < this.CACHE_DURATION) {
        console.log('Using cached pricing data');
        return this.cachedData;
      }
    }

    try {
      console.log('Fetching fresh CANONICAL pricing data from backend...');
      
      const response = await leaguesAPI.getPricingData(leagueId);
      
      if (!response.success || !response.players) {
        throw new Error('Failed to fetch pricing data');
      }

      // NO TRANSFORMATION - Just pass canonical through!
      this.cachedData = {
        players: response.players,  // Pure canonical: {ids, info, stats: {years: [...]}}
        metadata: response.metadata || {},  // Pass through full metadata (includes pricing_year, years, scoring_categories)
        scoring_categories: response.metadata?.scoring_categories || {},
        years: response.metadata?.years || [],
        timestamp: new Date().toISOString()
      };
      this.cacheTimestamp = Date.now();
      
      console.log(`✅ Loaded ${response.players.length} players in CANONICAL format (no transformation)`);
      
      return this.cachedData;
      
    } catch (error) {
      console.error('Error fetching pricing data:', error);
      throw error;
    }
  }

  clearCache() {
    this.cachedData = null;
    this.cacheTimestamp = null;
  }
}

export default new PricingDataService();
